import ChooseLevelScreen from "@memorang/ui/components/ChooseLevelScreen";
import type { NextButtonHandler } from "../types";

type Props = {
	handleSelectLevel: (levelId: string) => void;
	selectedLevelId?: string;
	handleNextAction: NextButtonHandler;
	cta?: string;
};

export const ChooseLevelContainer = ({
	handleSelectLevel,
	selectedLevelId,
	handleNextAction,
	cta,
}: Props) => {
	const handleNext = () => {
		handleNextAction(
			selectedLevelId === "national" ? "chooseContext" : "chooseState",
		);
	};

	return (
		<ChooseLevelScreen
			handleNext={handleNext}
			selectedLevelId={selectedLevelId}
			handleSelectLevel={handleSelectLevel}
			cta={cta}
		/>
	);
};
